"use strict";

exports.__esModule = true;
exports.RendererContext = void 0;

var _react = require("react");

/** @type {React.Context<{document: DocumentJson, tools: any[], language: {name: string, key: string}}>} */
var RendererContext = /*#__PURE__*/(0, _react.createContext)({
  document: {
    document: null,
    config: null,
    language: null,
    lines: null,
    version: null,
    width: null
  },
  tools: [],
  language: {
    name: "Français",
    key: "fr"
  }
});
exports.RendererContext = RendererContext;